function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useEffect } from 'react';
import { Icon } from '@ant-design/compatible';

function defaultItemRender(item, _) {
  return item.label;
}

export var Finder = function Finder(props) {
  var itemPath = [];
  var itemPathIds = [];
  var columns = [props.data];
  var columnFooterTuples = [];
  var itemReferences = [];
  useEffect(function () {
    itemReferences.forEach(function (ir) {
      ir.scrollIntoView({
        block: 'nearest'
      });
    });
  });

  if (props.selectedItemId) {
    itemPath = findPath(props.data, props.selectedItemId);
  }

  itemPath.forEach(function (item) {
    itemPathIds.push(item.id);
    var children = item.children || [];

    if (props.showEmptyColumns || children.length > 0) {
      columns.push(children);
    }
  });

  for (var i = 0; i <= itemPath.length; i++) {
    var _parentItem = i > 0 ? itemPath[i - 1] : undefined;

    var currentSelection = i < itemPath.length ? itemPath[i] : undefined;
    columnFooterTuples.push([_parentItem, currentSelection]);
  }

  if (props.maxVisualDepth && columns.length > props.maxVisualDepth) {
    columns = columns.slice(columns.length - props.maxVisualDepth);
    columnFooterTuples = columnFooterTuples.slice(columnFooterTuples.length - props.maxVisualDepth);
  }

  var render = function render() {
    // Items refs will be rebuilt as the dom is built out
    itemReferences.length = 0;
    var result = /*#__PURE__*/React.createElement("div", {
      className: "finder-wrapper"
    }, props.headerRender && /*#__PURE__*/React.createElement("div", {
      className: "finder-header"
    }, props.headerRender()), props.showBreadcrumbs && /*#__PURE__*/React.createElement("div", {
      className: "finder-breadcrumbs"
    }, renderBreadcrumbs()), props.finderRender ? props.finderRender() : /*#__PURE__*/React.createElement("div", {
      className: "finder-columns"
    }, columns.filter(function (items, idx) {
      return props.showEmptyColumns || items.length > 0;
    }).map(function (items, idx) {
      return /*#__PURE__*/React.createElement("ul", {
        key: idx,
        className: "finder-column"
      }, renderColumn(items));
    })), props.columnFooterRender && /*#__PURE__*/React.createElement("div", {
      className: "finder-column-footers"
    }, columnFooterTuples.map(function (columnFooterTuple, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "finder-column-footer"
      }, props.columnFooterRender(columnFooterTuple[0], columnFooterTuple[1]));
    })));
    return result;
  };

  function renderBreadcrumbs() {
    if (itemPath.length) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        className: "finder-breadcrumbs-crumb",
        onClick: function onClick(_) {
          return props.onItemSelection(null);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "home",
        theme: "filled"
      })), /*#__PURE__*/React.createElement("span", {
        className: "finder-breadcrumbs-delimiter"
      }, "/"), itemPath.map(function (item, idx) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: idx
        }, item.id === props.selectedItemId ? /*#__PURE__*/React.createElement("span", null, item.label) : /*#__PURE__*/React.createElement("a", {
          onClick: function onClick(_) {
            return props.onItemSelection(item);
          },
          className: "finder-breadcrumbs-crumb"
        }, item.label), /*#__PURE__*/React.createElement("span", {
          className: "finder-breadcrumbs-delimiter"
        }, "/"));
      }));
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  function renderColumn(items) {
    if (items.length) {
      return items.map(function (item) {
        var className = 'finder-item';
        var isActive = itemPathIds.includes(item.id);

        if (isActive) {
          className += ' active';
        }

        return /*#__PURE__*/React.createElement("li", {
          ref: function ref(itemRef) {
            if (isActive && itemRef != null) {
              itemReferences.push(itemRef);
            }
          },
          key: item.id,
          className: className,
          onClick: function onClick(_) {
            return props.onItemSelection(item);
          }
        }, props.itemRender ? props.itemRender(item, isActive) : defaultItemRender(item, isActive));
      });
    }

    return props.noResults || /*#__PURE__*/React.createElement("li", {
      className: "finder-column-empty-message"
    }, "No Results");
  }

  return render();
};
/**
 * Breadth-first recursive search to find the full path up to the given item id
 */

export function findPath(data, itemId) {
  var path = [];

  var _iterator = _createForOfIteratorHelper(data),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _item2 = _step.value;

      if (_item2.id === itemId) {
        path = [_item2];
        break;
      }
    } // Item was not found at this level. Try sub paths

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (path.length === 0) {
    var _iterator2 = _createForOfIteratorHelper(data),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _item = _step2.value;

        if (_item.children) {
          var subPath = findPath(_item.children, itemId); // Item was found in a sub path. Add this item to the sub path and return.

          if (subPath.length) {
            path = [_item].concat(subPath);
            break;
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return path;
}